module.exports = __webpack_public_path__ + "img/m-home-logo.9d21d0f1.png";